import React from 'react'

import { useWebViewBridge } from '@fourthwall/webview-bridge'
import { routing } from '@utils/routing'

import { useFilterGiftCards } from './modules/GiftCardsFilter'
import { GiftCardsInfinite } from './modules/GiftCardsInfinite/GiftCardsInfinite'
import { GiftCardsList } from './modules/GiftCardsList/GiftCardsList'

export const GiftCards = () => {
  const { hasFilterParams } = useFilterGiftCards()
  const { isWebView } = useWebViewBridge()

  const getEmptyStateProps = () => {
    if (hasFilterParams) {
      return {
        title: 'No gift cards found',
        subtitle: 'Adjust your filters.',
      }
    }

    return {
      title: "You haven't create any gift cards yet",
      subtitle:
        'Digital gift cards can be applied at checkout on any order. Any unused balance remains available for future purchases.',
      label: 'Create gift card',
      to: routing.promotions.giftCards.create.self,
    }
  }

  const emptyStateProps = getEmptyStateProps()

  if (isWebView) {
    return <GiftCardsInfinite emptyStateProps={emptyStateProps} />
  }

  return <GiftCardsList emptyStateProps={emptyStateProps} />
}
